import { OperatorsTable } from "@/features/operators/operators-table";

const OperatorsScreen = () => {
  return (
    <div className="p-4">
      <OperatorsTable />
    </div>
  );
};

export default OperatorsScreen;
